import { JtiDocumentAdditionalInfo } from '.';
import { PartyDTO } from './PartyDTO.model';

export class JtiDocumentAdditionalInfoForPartySelect extends JtiDocumentAdditionalInfo {
  value: PartyDTO[];
  documentCode: string;
  documentTitle: string;
}
